import React, { useEffect, useState } from "react";
import { Modal, Button, Container, Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import LifeInsurance from "../assets/LifeInsurance_service.webp";
import HealthInsurance from "../assets/HealthInsurance_serv.webp";
import MutualFunds from "../assets/MutualFund.webp";
import GeneralInsurance from "../assets/General_Insurance.webp";
import RetirementPlanning from "../assets/RetirementPlanning.webp";
import TaxPlanning from "../assets/TaxPlanning.webp";
import ChildEducation from "../assets/ChildEducation.webp";
import EstatePlanning from "../assets/EstatePlanning.webp";
import { Helmet } from "react-helmet";
import axios from 'axios';

const services = [
    {
        title: "Life Insurance",
        description: "Secure your family’s future with expert guidance from financial advisors in Mumbai & Kalyan-Dombivli. Get the right life cover today.",
        details:
            "Looking for a life insurance advisor near me? Our LIC agents and managers in Mumbai & Dombivli explain policies clearly and help you choose the right cover. With our advice, your family’s future is protected.",
        image: LifeInsurance,
        imageAlt: "LIC agent in Mumbai explaining life insurance options to a young family."
    },
    {
        title: "Health Insurance",
        description: "Stay prepared for medical emergencies with smart coverage, guided by trusted financial consultants near you.",
        details:
            "Rising medical costs demand smart protection. Our advisors and health insurance advisors near me recommend plans that balance coverage and affordability. We integrate personal finance expertise to keep your savings secure.",
        image: HealthInsurance,
        imageAlt: "Financial advisor in Dombivli helping client choose affordable health insurance."
    },
    {
        title: "Mutual Funds & SIPs",
        description: "Build long-term wealth with expert-managed investments recommended by our Mumbai financial advisors",
        details:
            "We make investing simple. Our investment advisors near me and asset managers design mutual fund and SIP strategies based on your risk appetite. With our guidance, you build long-term wealth confidently.",
        image: MutualFunds,
        imageAlt: "Investment manager in Mumbai guiding young professional on SIP and mutual funds."
    },
    {
        title: "General Insurance",
        description: "Protect your car, home, and travel with ease. Get custom insurance advice from local financial experts.",
        details:
            "Need protection for car, home, or travel? If you’re searching for a financial agent near me, our team provides trusted investment advice and wealth management solutions that keep your assets safe.",
        image: GeneralInsurance,
        imageAlt: "Client reviewing car and home insurance plans with financial consultant."
    },
    {
        title: "Retirement Planning",
        description: "Plan a financially free retirement with our financial advisors in Kalyan-Dombivli & Mumbai, ensuring peace of mind.",
        details:
            "Retirement should be stress-free. Our financial managers and investment managers in Mumbai & Dombivli create customized strategies combining SIPs, life insurance, and smart financial planning for your secure future.",
        image: RetirementPlanning,
        imageAlt: "Couple in Mumbai consulting financial manager for retirement planning."
    },
    {
        title: "Smart Tax Planning",
        description: "Legally save taxes and grow your income with personalized tax planning solutions from trusted financial planners.",
        details:
            "Don’t overpay taxes. Our financial advisors and investment advisors near me create personalized tax-saving strategies under Section 80C and beyond. Clients rely on our wealth managers and financial strategies to reduce tax burden while growing wealth.",
        image: TaxPlanning,
        imageAlt: "Advisor in Mumbai explaining tax-saving investment options to client."
    },
    {
        title: "Child Education Planning",
        description: "Give your child’s dreams a strong financial base with goal-based investment planning by our expert advisors.",
        details:
            "Secure your child’s future with strong financial planning. Our financial advisors, investment managers, and asset managers use SIPs, mutual funds, and insurance-linked plans to create dedicated education funds.",
        image: ChildEducation,
        imageAlt: "Parents in Dombivli discussing child education fund with financial advisor."
    },
    {
        title: "Estate & Legacy Planning",
        description: "Pass on your wealth smoothly and securely with guidance from experienced financial consultants in Mumbai.",
        details:
            "Passing on wealth requires care. Our financial advisors and wealth managers help you prepare wills, trusts, and succession plans. With trusted financial strategies Mumbai & Dombivli families rely on, your legacy is preserved.",
        image: EstatePlanning,
        imageAlt: "Wealth manager in Mumbai guiding client on wills, trusts, and estate planning."
    },
];

const Services = () => {
    const [selectedService, setSelectedService] = useState(null);

    useEffect(() => {
      wakeUpAPI();
    }, []);
  
    const wakeUpAPI = async () => {
      try {
        const response = await axios.get('https://sfa-blog.onrender.com/api/blogs?page=1&limit=1');
        // console.log('API woke up:', response.status);
      } catch (error) {
        // console.error('Error waking up API:', error.message);
      }
    };

    return (
        <div className="bg-light" style={{ paddingBottom: "80px" }}>
            <Container>
                <h2 className="text-center fw-bold mb-4" style={{ color: '#3a0063' }}>
                    Our Services
                </h2>
                <Row className="g-4">
                    {services.map((service, index) => (
                        <Col key={index} sm={12} md={6} lg={4} xl={3}>
                            <motion.div
                                whileHover={{ scale: 1.02 }}
                                transition={{ type: "spring", stiffness: 200 }}
                            >
                                <Helmet>
          <title>
            Shatrunjay Financial Advisors | Financial Advisors in Mumbai & Kalyan-Dombivli | Wealth Planning
          </title>
          <meta
            name="description"
            content="Trusted financial advisors in Mumbai & Kalyan-Dombivli. Expert tax saving, SIP, insurance & wealth planning. Book your free consultation today!"
          />
                                </Helmet>
                                <Card className="shadow-sm border-0 rounded-4 d-flex flex-column h-100" style={{ minHeight: "100%" }}>
                                    <div style={{ position: "relative" }}>
                                        <Card.Img
                                            variant="top"
                                            src={service.image}
                                            alt={service.imageAlt}
                                            className="rounded-top-4"
                                            style={{ height: "180px", objectFit: "cover" }}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                bottom: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "30%",
                                                background: "linear-gradient(to top, rgba(255,255,255,0.9), transparent)",
                                                borderBottomLeftRadius: "1rem",
                                                borderBottomRightRadius: "1rem",
                                            }}
                                        />
                                    </div>
                                    <Card.Body className="d-flex flex-column" style={{ flexGrow: 1 }}>
                                        <h3 className="fw-semibold text-dark mb-2 text-center"
                                        style={{minHeight: "48px", lineHeight: "1.2", display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textAlign: "center"
                                            }}
                                        >
                                            {service.title}
                                        </h3>
                                        <Card.Text
                                            className="text-muted small flex-grow-1 overflow-hidden"
                                            style={{
                                                display: "-webkit-box",
                                                WebkitLineClamp: 3,
                                                WebkitBoxOrient: "vertical",
                                                minHeight: "60px",
                                            }}
                                        >
                                            {service.description}
                                        </Card.Text>
                                        <button
                                            variant="primary"
                                            onClick={() => setSelectedService(service)}
                                            className="mt-auto rounded-pill py-1    "
                                            style={{
                                                backgroundColor: '#3a0063',
                                                color: 'white',
                                                border: 'none',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            View More
                                        </button>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    ))}
                </Row>

                {/* Modal */}
                <Modal
                    show={!!selectedService}
                    onHide={() => setSelectedService(null)}
                    centered
                    size="lg"
                    className="service-modal"
                >
                    <Modal.Header closeButton className="border-0 pb-0">
                        <Modal.Title className="fs-4 fw-bold">
                            {selectedService?.title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        <img
                            src={selectedService?.image}
                            alt={selectedService?.title}
                            className="img-fluid rounded mb-4"
                            style={{ maxHeight: "280px", objectFit: "cover", width: "100%" }}
                        />
                        <p className="text-muted fs-6">{selectedService?.details}</p>
                    </Modal.Body>
                    <Modal.Footer className="border-0 pt-0">
                        <Button
                            variant="outline-secondary"
                            onClick={() => setSelectedService(null)}
                            className="rounded-pill px-4"
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </div>
    );
};

export default Services;
